import(/* webpackMode: "eager" */ "/app/apps/team-leagues/src/app/team-leagues/[teamLeagueId]/(player-details)/player-details/[playerId]/error.tsx");
